import React, { useState, useMemo, useEffect } from "react";
import { Calendar } from "react-calendar";
import { Button, Modal, Typography } from "antd";
import tz_lookup from "tz-lookup";
import { DateTime } from "luxon";
import "react-calendar/dist/Calendar.css";

const AvailabilityDatesCalender = ({
  availableTimes,
  handleDateTimeSelect,
  lat,
  long,
  advanceNoticeDays = "7",
}) => {
  const { Title, Paragraph, Text } = Typography;

  const [filteredAvailableTimes, setFilteredAvailableTimes] = useState({});
  const [availableTimesOfADay, setAvailableTimesOfADay] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isTimeModalVisible, setIsTimeModalVisible] = useState(false);

  const timezoneOfTripCreator = useMemo(() => {
    return tz_lookup(lat, long);
  }, [lat, long]);

  useEffect(() => {
    // Calculate cutoff date based on advanceNoticeDays
    const today = DateTime.now().startOf("day");
    const cutoffDate = today.plus({ days: parseInt(advanceNoticeDays) });

    // Filter out dates that fall within the advanceNoticeDays period
    const newFilteredTimes = Object.keys(availableTimes).reduce((acc, date) => {
      const availableDate = DateTime.fromISO(date);
      if (availableDate >= cutoffDate) {
        acc[date] = availableTimes[date];
      }
      return acc;
    }, {});

    setFilteredAvailableTimes(newFilteredTimes);
  }, [availableTimes, advanceNoticeDays]);

  const handleDateSelect = (selectedDateString) => {
    setSelectedDate(selectedDateString);
    setIsTimeModalVisible(true);
    setAvailableTimesOfADay(filteredAvailableTimes[selectedDateString]);
  };

  const handleTimeSelect = (time) => {
    handleDateTimeSelect(time);
    setIsTimeModalVisible(false);
  };

  return (
    <>
      <Calendar
        tileContent={({ date }) => {
          const formattedDate = date.toISOString().split("T")[0];
          const availableDate = filteredAvailableTimes[formattedDate];
          const today = new Date().toISOString().split("T")[0];

          return (
            availableDate && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "6px",
                    height: "6px",
                    backgroundColor: "rgb(255, 149, 0)",
                    borderRadius: "50%",
                  }}
                ></div>
              </div>
            )
          );
        }}
        onChange={(date) => {
          const selectedDate = date.toISOString().split("T")[0];
          const dateAvailable = filteredAvailableTimes[selectedDate];

          const today = new Date().toISOString().split("T")[0];

          if (dateAvailable && selectedDate >= today) {
            handleDateSelect(selectedDate);
          } else {
            console.log("Selected date is not available");
          }
        }}
        style={{ padding: "10px" }}
      />

      <Modal
        title={
          <Title style={{ margin: 0 }} level={4}>
            Select Time Slot
          </Title>
        }
        open={isTimeModalVisible}
        onCancel={() => setIsTimeModalVisible(false)}
        footer={null}
      >
        <div style={{ fontWeight: "500", color: "grey" }}>
          {availableTimesOfADay[0]?.date}
        </div>
        <div
          style={{
            fontWeight: "500",
            marginBottom: "10px",
            color: "grey",
          }}
        >
          {timezoneOfTripCreator}
        </div>
        <div>
          {availableTimesOfADay.map((time) => (
            <Button
              key={Math.random()}
              onClick={() => handleTimeSelect(time)}
              style={{
                margin: "5px",
                width: "100%",
                fontWeight: "500",
                color: "black",
              }}
            >
              {time?.startTime} {time?.endTime}
            </Button>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default AvailabilityDatesCalender;
